import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
    selector: 'app-top-area-card',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './top-area-card.html',
})
export class TopAreaCardComponent {
    @Input() areaName = '';
    @Input() propertiesCount = 0;
    @Input() thumbnail = '';
    @Input() isFeatured = false;

    constructor(private router: Router) {}

    goToArea() {
        if (this.areaName) {
            this.router.navigate(['/all-properties'], { queryParams: { title: this.areaName } });
        }
    }

    get safeAreaName(): string {
        return (this.areaName || '').trim() || 'Area';
    }

    get propertiesText(): string {
        return `${this.propertiesCount.toLocaleString('en-US')} Properties`;
    }
}